
export default class Contact {

  public name: string;
  public title: string;
  public email: string;
  public phoneNumber?: string;
  public image?: string;

//   <ContactRow name={"John Smith"} title={"Title"} email={"john.smith@dynatrace.com"} phoneNumber={"Tel. +1 630-886-9981"} image={matt_howard} />
  constructor(name: string, title: string, email: string, phoneNumber?: string, image?: string) {
    this.name = name;
    this.title = title;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.image = image;
  }

}
